(() => {
  const formatEUR = (cents) =>
    new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(cents / 100);

  async function fetchCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("cart.js nicht erreichbar");
    return res.json();
  }

  function getGate() {
    // Cart drawer kann mehrfach im DOM landen — nimm den im Drawer
    const drawer = document.querySelector("#cart-drawer");
    return drawer ? drawer.querySelector(".min-order-gate") : document.querySelector(".min-order-gate");
  }

  function getCheckoutButton(gate) {
    // 1) bevorzugt: über Klasse, falls render 'button' class unterstützt
    let btn = gate.querySelector(".min-order-checkout");
    if (btn) return btn;

    // 2) fallback: Shopify checkout button im selben form suchen
    const form = gate.closest("form");
    if (!form) return null;
    return form.querySelector('button[name="checkout"], input[name="checkout"]');
  }

  async function update() {
    const gate = getGate();
    if (!gate) return;

    const msg = gate.querySelector(".min-order-msg");
    const btn = getCheckoutButton(gate);
    if (!msg || !btn) return;

    const minCents = parseInt(gate.dataset.minOrderCents || "0", 10);

    let cart;
    try {
      cart = await fetchCart();
    } catch (e) {
      // Fail-open: wenn wir Cart nicht lesen können, nicht blocken
      gate.classList.remove("is-blocked");
      msg.textContent = "";
      btn.disabled = false;
      btn.removeAttribute("aria-disabled");
      btn.removeAttribute("title");
      return;
    }

    // Warenwert (ohne Versand) = total_price aus cart.js
    // Hinweis: cart.js liefert bereits nach Discounts, aber ohne Versand.
    const subtotalCents = cart.total_price;
    const missing = Math.max(0, minCents - subtotalCents);

    if (missing > 0) {
      gate.classList.add("is-blocked");
      msg.textContent = `Mindestbestellwert: ${formatEUR(minCents)} – es fehlen noch ${formatEUR(missing)}.`;

      btn.disabled = true;
      btn.setAttribute("aria-disabled", "true");
      btn.setAttribute("title", msg.textContent);
    } else {
      gate.classList.remove("is-blocked");
      msg.textContent = "";

      btn.disabled = false;
      btn.removeAttribute("aria-disabled");
      btn.removeAttribute("title");
    }
  }

  // initial
  document.addEventListener("DOMContentLoaded", update);

  // Cart drawer updated sehr dynamisch → MutationObserver
  const observer = new MutationObserver(() => {
    clearTimeout(window.__minOrderGateTO);
    window.__minOrderGateTO = setTimeout(update, 120);
  });
  observer.observe(document.documentElement, { subtree: true, childList: true });

  // optional: falls Theme Events feuert
  document.addEventListener("cart:updated", update);
})();
